import { Formik, Form } from "formik";
import * as Yup from "yup";
import MainLayout from "../../layout";
import FormTextField from "../../components/form/text";
import { useNavigate, useParams } from "react-router-dom";
import successToast from "../../components/toast/successToast";
import errorToast from "../../components/toast/errorToast";
import { useEffect, useState } from "react";
import { FormDropDown } from "../../components/form/dropdown";
import { FormTextAreaField } from "../../components/form/text-area";
import { FormMultiFileUploadField } from "../../components/form/multi-file";
import { api } from "../../redux/apis/api";

const EditMarketingMaterials = () => {
  const naviagte = useNavigate();
  const params = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [categoryList, setcategoryList] = useState([]);

  const initialValues = {
    id: params?.id,
    marketing_material_category: data?.marketing_material_category ?? "",
    title: data?.title ?? "",
    description: data?.description ?? "",
    file: data?.file?.length ? data?.file : [],
    status: data?.status ?? "",
  };

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Required"),
  });

  const handleSubmit = (values) => {
    console.log(values, "values");
    api
      .post(`/marketing-materials/edit`, values)
      .then((response) => {
        successToast(response.message);
        naviagte(`/marketing-materials/list`);
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const fetchData = () => {
    setLoading(true);
    api
      .post(`/marketing-materials/read`, {
        id: params?.id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const statusOptions = [
    {
      label: "Active",
      value: "active",
    },
    {
      label: "Inactive",
      value: "inactive",
    },
    {
      label: "Draft",
      value: "draft",
    },
  ];

  const fetchCategoryDropDownData = () => {
    api
      .get(`/marketing-materials/category-drop-down`)
      .then((res) => {
        let newArr = res?.data?.data?.categories?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setcategoryList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  useEffect(() => {
    fetchCategoryDropDownData();
  }, []);

  return (
    <MainLayout>
      <section className="h-full overflow-auto md:px-3">
        {loading ? (
          <div className="h-full flex justify-center items-center">
            <div>
              <div className="animate-spin rounded-full h-10 w-10 border-4 border-primary border-t-transparent mx-2"></div>
              <p className="mt-2 text-sm text-gray-500">Loading...</p>
            </div>
          </div>
        ) : (
          <>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize={true}
            >
              {({ values }) => (
                <Form>
                  <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
                    <h2 className="text-xl font-semibold capitalize">
                      marketing materials - Edit
                    </h2>
                    <div className="flex gap-3 items-center">
                      <button
                        onClick={() => naviagte("/marketing-materials/list")}
                        type="button"
                        className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                      >
                        Save
                      </button>
                    </div>
                  </div>

                  <section className="w-full max-w-[40rem]">
                    <div className="my-4">
                      <FormTextField
                        name={"title"}
                        label={"title"}
                        placeholder={`Enter title`}
                      />
                    </div>
                    <div className="my-4">
                      <FormTextAreaField
                        name={"description"}
                        label={"description"}
                        placeholder={`Enter description`}
                        rows={3}
                      />
                    </div>
                    <div className="my-4">
                      <FormDropDown
                        name="marketing_material_category"
                        label="marketing material category"
                        options={categoryList}
                        value={categoryList?.find(
                          (item) =>
                            item?.value === values?.marketing_material_category
                        )}
                      />
                    </div>
                    <div className="my-4">
                      <FormDropDown
                        name="status"
                        label="status"
                        options={statusOptions}
                        value={statusOptions?.find(
                          (item) => item?.value === values?.status
                        )}
                      />
                    </div>
                    <div className="my-4">
                      <FormMultiFileUploadField
                        name={"file"}
                        label={"files"}
                        accept=".pdf,.doc,.docx,.jpg,.png"
                      />
                    </div>
                  </section>
                </Form>
              )}
            </Formik>
          </>
        )}
      </section>
    </MainLayout>
  );
};

export default EditMarketingMaterials;
